// Importing styles from PaymentOffer
import paymentOfferStyle from "../views/PaymentOffer";

// Defining styles for report tables
const tableStyle = theme => ({
  // General table styles
  table: {
    minWidth: 650, // Minimum width
    borderRadius: "1em", // Rounded corners
    overflow: "hidden", // Hide overflow
  },
  // Styles for notes table
  notestable: {
    minWidth: 500, // Minimum width
    overflow: "hidden", // Hide overflow
  },
  TableContainer: { borderRadius: "1em" },
  ...paymentOfferStyle,
  visuallyHidden: {
    border: 0, // No border
    clip: "rect(0 0 0 0)", // Clip to rectangle
    height: 1, // Minimal height
    margin: -1, // Negative margin
    overflow: "hidden", // Hide overflow
    padding: 0, // No padding
    position: "absolute", // Absolute positioning
    top: 20, // Top position
    width: 1, // Minimal width
  },
  // Styles for grid items in expiry section
  expirtItemGrid: {
    display: "flex", // Flexbox layout
    justifyContent: "flex-end", // Align to the end
    padding: "5px", // Padding
    width: "inherit", // Inherit width
  },
  // Styles for clear button
  clearButton: {
    backgroundColor: theme.palette.primary.dark, // Dark primary color
    height: "32px", // Fixed height
    color: theme.palette.primary.contrastText, // Contrast text color
    "&:hover": {
      backgroundColor: theme.palette.primary.dark, // Dark primary color on hover
    },
  },
  // Styles for modal header
  statusModalHeader: {
    display: "flex", // Flexbox layout
    height: "25px", // Fixed height
    flexDirection: "row", // Row layout
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
    backgroundColor: theme.palette.primary.main, // Primary background color
    padding: "2%", // Padding
    borderTopLeftRadius: "12px", // Rounded top-left corner
    borderTopRightRadius: "12px", // Rounded top-right corner
  },
  // Padding for modal content
  statusModalPadding: {
    padding: "1%", // Padding
  },
  // Styles for status heading text
  statusHeadingText: {
    textAlign: "center", // Centered text
    width: "90%", // Width
    color: "#fff", // White text color
    fontSize: "16px", // Font size
    fontWeight: "bold", // Bold font weight
  },
  // Styles for root of status modal
  statusRoot: {
    maxWidth: "69%", // Maximum width
  },
  // Styles for back button margin
  marginBackButton: {
    marginTop: "2%", // Top margin
    marginLeft: "2%", // Left margin
  },
  // Styles for table header cell text
  cellTextHeader: {
    fontSize: "13px", // Font size
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
    color: theme.palette.primary.dark, // Dark primary color
    fontWeight: "bold", // Bold font weight
  },
  // Styles for table header cell text in offers
  cellTextHeaderOffer: {
    fontSize: "13px", // Font size
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
    color: theme.palette.tableColor.tableHeaderTextColor, // Table header text color
    fontWeight: "bold", // Bold font weight
    padding: "16px 10px", // Padding
    "&:hover": {
      color: theme.palette.tableColor.tableHeaderTextColor, // Table header text color on hover
    },
  },
  // Styles for table cell text
  cellText: {
    fontSize: "12.5px", // Font size
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
    color: "#000", // Black text color
    padding: "16px 10px", // Padding
    whiteSpace: "nowrap", // Prevent text wrapping
  },
  // Styles for table header cell with sign
  cellHeadSign: {
    cursor: "pointer", // Pointer cursor
    "&:hover": {
      background: "#eeeeee", // Light gray background on hover
    },
  },
  // Styles for modal root
  modalRoot: {
    width: "400", // Width
    height: "auto", // Auto height
    maxHeight: "400px", // Maximum height
    maxWidth: "450px", // Maximum width
  },
  modalRootAcc: {
    width: "300px",
    height: "auto",
    maxHeight: "400px",
    maxWidth: "450px",
  },
  modalRootXs: {
    width: "80%", // Width
  },
  // Styles for modal root with upload
  modalRootUpload: {
    width: "40%", // Width
    marginTop: "10%", // Top margin
    height: "auto", // Auto height
    padding: "30px", // Padding
    paddingTop: "10px", // Top padding
    alignItems: "center", // Center alignment
    justifyContent: "center", // Center justification
  },
  // Styles for dropdown select
  selectDropdown: {
    fontSize: "14px", // Font size
  },
  // Styles for menu items
  menuItem: {
    fontSize: "14px", // Font size
  },
  // Styles for table cell description text
  cellTextDiscription: {
    fontSize: "80%", // Font size
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
    color: theme.palette.primary.main, // Primary color
  },
  // Styles for success text
  successText: {
    color: "gray", // Gray text color
    fontSize: "large", // Large font size
  },
  // Styles for margin
  margin: {
    width: "100%", // Full width
    alignItems: "center", // Center alignment
    justifyContent: "space-around", // Space around justification
  },
  // Styles for margin top
  marginTop: {
    margin: "1%", // Margin
  },
  modalDiv: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "stretch",
  },
  modalCard: {
    padding: "30px", // Padding
    position: "absolute", // Absolute positioning
    top: "50%", // Top position
    left: "50%", // Left position
    transform: "translate(-50%, -50%)", // Center alignment
  },
  // Styles for search container
  searchContainer: {
    display: "flex", // Flexbox layout
    paddingLeft: "10px", // Left padding
    flexDirection: "row", // Row layout
    padding: "1%", // Padding
  },
  // Styles for button
  buttonStyle: {
    backgroundColor: theme.palette.primary.main, // Primary background color
    margin: "0.5%", // Margin
    color: theme.palette.primary.contrastText, // Contrast text color
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0 14px 26px -12px rgb(153 153 153 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(153 153 153 / 20%)",
    },
    textTransform: "capitalize",
    padding: "9px 25px",
    fontSize: "14px",
    lineHeight: "0.9",
    borderRadius: "3px",
    height: "32px",
  },
  ExportButtonStyle: {
    backgroundColor: theme.palette.primary.main,
    margin: "0.5%",
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0 14px 26px -12px rgb(153 153 153 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(153 153 153 / 20%)",
    },
    textTransform: "capitalize",
    padding: "9px 25px",
    fontSize: "14px",
    lineHeight: "0.9",
    height: "32px",
    borderRadius: "3px",
  },
  activeInputColor: {
    // "& .MuiSelect-nativeInput": {
    //   position: "inherit",
    //   width: "auto",
    // },
  },
  resize: {
    fontSize: "14px",
    fontStyle: "Helvetica, Arial,sans-serif",
    color: theme.palette.primary.dark,
  },
  dialogBoxDropDown: {
    width: "auto",
    color: theme.palette.primary.dark,
    overflow: "hidden",
    marginRight: "2%",
    marginLeft: "2%",
    fontSize: ".7rem",
    boxSizing: "border-box",
    fontFamily: "Roboto\", \"Helvetica\", \"Arial\", sans-serif",
    fontWeight: "200",
    lineHeight: "1.5",
    "&:hover": {
      backgroundColor: "#00aab4",
      color: "#fff",
    },
  },
  searchWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  searchWrapper1: {
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  root: {
    width: "30%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  rootOverLay: {
    width: "30%",
    padding: "1%",
    position: "absolute",
    zIndex: 5000,
    cursor: "pointer",
    backgroundColor: theme.palette.primary.contrastText,
    boxShadow: "1px 1px 2px white, 0 0 25px #d6d0d0, 0 0 5px #737373",
  },
  rootPagination: {
    flexShrink: 0,
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    borderTop: `2px solid ${theme.palette.primary.main}`,
  },
  overLayBox: {
    position: "absolute",
    [theme.breakpoints.down("sm")]: {
      width: "91%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "30%",
    },
    padding: "1%",
    zIndex: 999,
    cursor: "pointer",
    backgroundColor: theme.palette.primary.contrastText,
    boxShadow: "1px 1px 2px white, 0 0 25px #d6d0d0, 0 0 5px #737373",
  },
  notesOverLayBox: {
    position: "absolute",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "35%",
    },
    padding: "1%",
    zIndex: 999,
    cursor: "pointer",
    backgroundColor: theme.palette.primary.contrastText,
    boxShadow: "1px 1px 2px white, 0 0 25px #d6d0d0, 0 0 5px #737373",
  },
  dialogScrollBar: {
    overflowY: "auto",
    padding: "0 1rem",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#e4e4e4",
      borderRadius: "50px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "50px",
    },
  },
  notesdialog: {
    // marginTop: "2%",
    maxHeight: "80vh",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
    [theme.breakpoints.down("md")]: {
      width: "75%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
  },
  notestableScroll: {
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#e4e4e4",
      borderRadius: "30px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "30px",
    },
  },
  bottonPage: {
    borderRadius: "100%",
    backgroundColor: theme.palette.primary.main,
    fontSize: "14px",
    color: "#fff",
    height: "34px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  inputBox: {
    margin: "10px",
    marginTop: "20px",
    color: "#bfbdbd",
  },
  fullInput: {
    width: "93.2%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  halfInput: {
    width: "87%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  halfInputSingle: {
    width: "87%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  withoutOption: {
    width: "26.8%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  quaterInput: {
    width: "73%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  activeInputLableColor: {
    fontSize: "14px",
    "&.focused": {
      color: theme.palette.primary.main,
    },
  },
  chipContainer: {
    maxHeight: "10px",
  },
  activeInputLableBestOffer: {
    fontSize: "130%",
    "&.focused": {
      color: theme.palette.primary.main,
    },
  },
  FName: {
    width: "10%",
  },
  ClientID: {
    width: "10%",
  },
  Email: {
    width: "10%",
  },
  Phone: {
    width: "10%",
  },
  Role: {
    width: "10%",
  },
  Created_date: {
    width: "10%",
  },
  status: {
    width: "10%",
  },
  DBA_Name: {
    width: "20%",
  },
  E_mail: {
    width: "10%",
  },
  OwnershipType: {
    width: "15%",
  },
  Contact_Name: {
    width: "15%",
  },
  Creation_Date: {
    width: "10%",
  },
  Update_Date: {
    width: "10%",
  },
  activityDBAName: {
    width: "10%",
  },
  activityEMail: {
    width: "10%",
  },
  activityOwnershipType: {
    width: "10%",
  },
  activityContactName: {
    width: "10%",
  },
  activityPhone: {
    width: "10%",
  },
  activityCreationDate: {
    width: "10%",
  },
  activityUpdateDate: {
    width: "10%",
  },
  noDataImage: {
    height: "200px",
  },
  buttonBlink: {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  appSvgIcons: {
    position: "relative",
    height: "40px",
    width: "40px",
    cursor: "pointer",
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  actionButtonStyle: {
    width: "70px",
    height: "30px",
  },
  dialogBoxBorder: {
    borderRadius: "12px",
  },
});

export default tableStyle;
